const baseSize = 16;
function setRem() {
    let scale = document.documentElement.clientHeight / 1080;
    if (document.documentElement.clientWidth < 1280) scale = 1280 / 1920
    document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 1)}px`;
}
setRem();
window.onresize = () => {
    setRem();
};